import styled from 'styled-components';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

export const LogoContainer = styled.div`
  margin-bottom: 17px;
  img {
    max-width: 100%;
    object-fit: contain;
    height: 36px;
  }

  @media ${MediaQueryBreakpoints.isXsm} {
    margin-bottom: 0;
  }
`;
